// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "clipPlaneFragmentDeclaration";
const shader = `#ifdef CLIPPLANE
varying fClipDistance: f32;#endif
#ifdef CLIPPLANE2
varying fClipDistance2: f32;#endif
#ifdef CLIPPLANE3
varying fClipDistance3: f32;#endif
#ifdef CLIPPLANE4
varying fClipDistance4: f32;#endif
#ifdef CLIPPLANE5
varying fClipDistance5: f32;#endif
#ifdef CLIPPLANE6
varying fClipDistance6: f32;#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStoreWGSL[name] = shader;
/** @hidden */
export const clipPlaneFragmentDeclaration = { name, shader };
